import { translate } from 'components/Translation';
import React from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';
import { BodyS } from 'components/Typography/Typography';

interface IConfirmationDialogProps {
	isOpen: boolean;
	hideDialog: () => void;
	showEditDepartmentDialog: () => void;
	deleteDepartment: () => void;
}

const DeleteDepartmentConfirmationDialog = ({
	isOpen,
	hideDialog,
	showEditDepartmentDialog,
	deleteDepartment,
}: IConfirmationDialogProps) => {
	const deleteDepartmentClicked = () => {
		hideDialog();
		deleteDepartment();
	};

	const cancelClicked = () => {
		hideDialog();
		showEditDepartmentDialog();
	};

	return (
		<ConfirmationDialog
			isOpen={isOpen}
			hideDialog={hideDialog}
			header={`${translate('departments.delete.department')}?`}
			dialogBody={
				<div>
					<BodyS color="primary-light">{translate('departments.do.you.want.delete')}</BodyS>
					<BodyS color="primary-light">{translate('departments.number.users.will.not.be.assigned')}</BodyS>
					<BodyS color="primary-light">{translate('departments.number.users.will.not.be.removed')}</BodyS>
				</div>
			}
			buttons={[
				{
					text: translate('cancel'),
					onClick: cancelClicked,
					color: 'tertiary-light',
				},
				{
					text: translate('delete.it'),
					onClick: deleteDepartmentClicked,
					color: 'primary-light',
				},
			]}
		/>
	);
};

export default DeleteDepartmentConfirmationDialog;
